import iconPathCardGroup from 'raw-loader!@/assets/icon-path-card-group.txt';
import iconPathCardInvitation from 'raw-loader!@/assets/icon-path-card-invitation.txt';
import iconPathCardPersonal from 'raw-loader!@/assets/icon-path-card-personal.txt';
import iconPathVideoGroup from 'raw-loader!@/assets/icon-path-video-group.txt';
import iconPathVideoInvitation from 'raw-loader!@/assets/icon-path-video-invitation.txt';
import iconPathVideoPersonal from 'raw-loader!@/assets/icon-path-video-personal.txt';
import iconPathGiftGroup from 'raw-loader!@/assets/icon-path-gift-group.txt';
import iconPathGiftPersonal from 'raw-loader!@/assets/icon-path-gift-personal.txt';

const BY_ORDER_TYPE = {
  PERSONAL: {
    desc: 'From you only',
    deliveryTitle: 'deliver the card',
    recipientType: 'recipient',
    send: 'Use Ellacard to send via email / text',
    share: "I'll share a link",
    shareBtn: 'Share delivery link',
    icon: iconPathCardPersonal,

    CARD: {
      type: 'card',
      name: 'Personal card',
      deliveryTitle: 'deliver the card',
      emailSubject: 'You received a card'
    },
    GIFT: {
      type: 'gift card',
      name: 'Personal gift',
      deliveryTitle: 'deliver the gift card',
      emailSubject: 'You received a gift',
      icon: iconPathGiftPersonal
    },
    VIDEO: {
      type: 'video',
      name: 'Personal video',
      desc: 'Only you can add content',
      deliveryTitle: 'deliver the video',
      emailSubject: 'You received a video',
      icon: iconPathVideoPersonal
    }
  },

  GROUP: {
    recipientType: 'recipient',
    send: 'Use Ellacard to send via email / text',
    share: "I'll share a link",
    shareBtn: 'Share delivery link',
    icon: iconPathCardGroup,

    CARD: {
      type: 'card',
      name: 'Group card',
      desc: 'Invite contributors to sign',
      contributorTitle: 'sign this group card',
      contributorTitlePast: 'signed this card',
      contributorAction: 'signing',
      contributorOptionsTitle: 'Group signing',
      shareContributors: "I'll send / post a link to sign the card",
      shareBtnContributors: 'Share group signing link',
      deliveryTitle: 'deliver the signed / completed card',
      deliveryDisambiguation: 'signed / completed card',
      emailSubject: 'You received a card',
      emailSubjectContributors: "You've been invited to sign a group card on Ellacard",
      statusPast: 'Card has been signed'
    },
    GIFT: {
      type: 'gift card',
      name: 'Group gift',
      desc: 'Invite contributors to add value',
      contributorTitle: 'add value to this gift card',
      contributorTitlePast: 'added value to this gift card',
      contributorAction: 'adding value',
      contributorOptionsTitle: 'Group contribution',
      shareContributors: "I'll send / post a link",
      shareBtnContributors: 'Share contribution link',
      deliveryTitle: 'deliver the gift card',
      deliveryDisambiguation: 'final gift card',
      emailSubject: 'You received a gift',
      emailSubjectContributors: "You've been invited to contribute to a gift on Ellacard",
      statusPast: 'Value has been added',
      icon: iconPathGiftGroup
    },
    VIDEO: {
      type: 'video',
      name: 'Group video',
      desc: 'Invite contributors to add content',
      contributorTitle: 'add content to this video project',
      contributorTitlePast: 'added content to this video project',
      contributorAction: 'adding content',
      contributorOptionsTitle: 'Group editing',
      shareContributors: "I'll send / post a link",
      shareBtnContributors: 'Share contribution link',
      deliveryTitle: 'deliver the completed video',
      deliveryDisambiguation: 'completed video',
      emailSubject: 'You received a video',
      emailSubjectContributors: "You've been invited to add to a group video on Ellacard",
      statusPast: 'Content has been added',
      icon: iconPathVideoGroup
    }
  },

  INVITATION: {
    type: 'invitation',
    name: 'Event invitation',
    desc: 'Includes RSVPs',
    deliveryTitle: 'invite guests',
    recipientType: 'guest',
    send: 'Use Ellacard to invite guests via email / text',
    share: "I'll share an RSVP link",
    shareBtn: 'Share RSVP link',
    emailSubject: "You're invited",
    icon: iconPathCardInvitation,

    VIDEO: {
      type: 'video invitation',
      name: 'Video invitation',
      icon: iconPathVideoInvitation
    }
  }
};


// Returns information that we can use to build the UI
// - type
// - name
// - desc
// - deliveryTitle: "How do you want to [deliveryTitle]?"
// - recipientType
// - send
// - share
// - shareBtn
// - icon
export default function(orderType, coverType) {
  const info = BY_ORDER_TYPE[orderType];
  return { ...info, ...(info[coverType] || {}) };
};
